import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramFinanceMetricsPage } from './program-finance-metrics';

@NgModule({
  declarations: [
    ProgramFinanceMetricsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramFinanceMetricsPage),
  ],
})
export class ProgramFinanceMetricsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-finance-metrics/program-finance-metrics.module.ts